import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { PackPreset } from '../types/preset.types';
import { packApi } from '../api';
import { packKeys } from './pack.keys';

export function usePackPresets(
  packId?: string,
  options?: Omit<UseQueryOptions<PackPreset[], Error>, 'queryKey' | 'queryFn'>
) {
  const queryKey = packId ? packKeys.presets(packId) : [...packKeys.details(), 'presets', ''];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!packId) throw new Error('packId não informado');
      return packApi.getPresets(packId, signal);
    },
    enabled: Boolean(packId),
    ...(options as Omit<UseQueryOptions<PackPreset[], Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao carregar presets do pack',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    presets: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
